import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import { Link } from "react-router-dom"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import { loadingStatus, getPayload } from "actions"
import settings from "settings"
import axios from "axios"

class BuilderManagmenet extends Component {
	constructor(props) {
		super(props)

		this.state = {
			feeds: [],
			columns: [
				{
					Header: "ID",
					accessor: "id",
				},
				{
					Header: "Builder",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Legal Name",
					accessor: "legal_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "legal_name"),
				},
				{
					Header: "Feeds Setup In",
					accessor: "feeds_in",
					filterMethod: (f, r) => helpers.tableText(f, r, "feeds_in"),
				},
				{
					Header: "Code for Lot Status Map",
					accessor: "code",
					filterMethod: (f, r) => helpers.tableText(f, r, "code"),
				},
				{
					Header: "Communities",
					accessor: "communities",
					filterMethod: (f, r) => helpers.tableText(f, r, "communities"),
				},
				{
					Header: "Edit",
					accessor: "edit",
					filterable: false,
				},
			],
		}
	}

	componentDidMount() {
		this.getData()
	}

	getData = () => {
		this.props.loadingStatus(true)
		let userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getBuilderFeeds",
				{
					properties: this.props.activeProperties,
				},
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then((resp) => {
				if (resp.data.status == 400) {
					this.setState({ feeds: [] }, () => this.props.loadingStatus(false))
					this.props.loadingStatus(false)
				} else if (resp.status == 200) {
					this.setState(
						{
							feeds: resp.data.data,
						},
						() => {
							this.props.loadingStatus(false)
						}
					)
				} else {
					this.setState({ feeds: [] }, () => this.props.loadingStatus(false))
				}
			})
	}

	buildTable = (type) => {
		let data = []
		_.forEach(this.props.payload.public.builders, (v) => {
			let p = {}
			let feedsString = ""
			let feeds = []
			_.forEach(this.state.feeds.files, (file) => {
				if (file.builder === v.id) {
					feeds.push(file.property)
				}
			})
			_.forEach(this.state.feeds.urls, (url) => {
				if (url.builder === v.id) {
					feeds.push(url.property)
				}
			})
			if (feeds.length > 0) {
				feeds = _.uniq(feeds)
				_.forEach(feeds, (f) => {
					let property = _.find(this.props.payload.public.properties, { id: f })
					if (property) {
						feedsString += `${property.name}, `
					}
				})
			}
			feedsString = _.trim(feedsString, ", ")
			p.feeds_in = feedsString
			p.name = v.name
			p.id = v.id
			p.legal_name = v.legal_name
			p.code = v.code
			p.communities = ``
			_.forEach(v.properties, (r) => {
				let property = _.find(this.props.payload.public.properties, { id: r })
				if (!property) return
				p.communities += `${property.name}, `
			})
			p.communities = _.trim(p.communities, ", ")
			if (settings?.lotContracts) {
				p.finance_name = v.finance_name
				p.finance_address = v.finance_address
				p.finance_city = v.finance_city
				p.finance_state = v.finance_state
				p.finance_zip = v.finance_zip
			}
			p.edit = (
				<Link to={`/admin/builders/${p.id}`}>
					<i className="far fa-edit"></i>
				</Link>
			)

			data.push(p)
		})
		return data
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<Title title="Builder Management" showDate={false} />
					<div className="content">
						<div className="admin__add">
							<Link to={"/admin/builders/add"}>
								<i className="fas fa-plus-circle" />
							</Link>
						</div>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="builders"
							title="Builders"
							unset={["edit"]}
							classNames="small"
						/>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
		loadingStatus: state.loadingStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderManagmenet)
